import type { SelectItem } from '@vrplatform/components';
import { type Query, useQuery } from '../graphql';
import { useTeam } from '../hooks/team';

export const STORYBOOK_TAX_RATES_QUERY_KEY = 'taxRates';

export const getTaxRatesQuery = (
  q: Query,
  args: {
    teamId: string;
  }
) =>
  q
    .rates({
      order_by: [
        {
          name: 'asc',
        },
      ],
      where: {
        tenantId: { _eq: args.teamId },
        type: { _eq: 'tax' },
        status: { _eq: 'active' },
      },
    })
    .map<SelectItem & { percentageSuperBasePoints: number }>((rate) => {
      return {
        label: rate.name || 'No name',
        value: rate.id,
        percentageSuperBasePoints: rate.basisPoints ?? 0,
      };
    });

export function useTaxRatesQuery(args?: {
  skip?: boolean;
  storybookQueryKey?: string;
}) {
  const [{ id: teamId }] = useTeam();

  return useQuery(
    (q, args) => {
      return getTaxRatesQuery(q, args);
    },
    {
      keepPreviousData: true,
      variables: {
        teamId,
      },
      queryKey: ['taxRates'],
      skip: args?.skip || !teamId,
      storybookQueryKey:
        args?.storybookQueryKey ?? STORYBOOK_TAX_RATES_QUERY_KEY,
    }
  );
}
